<template>
  <h1>Create {{ measurementDefinition.name }} measurement</h1>
  <form @submit="submit">
    <v-number-input
      v-model="measurement"
      density="compact"
      label="value"
      :precision="measurementDefinition.exponent"
      v-bind="{
        ...(step !== null && { step }),
        ...(max !== null && { max }),
        ...(min !== null && { min }),
      }"
    />
    <v-btn type="submit">submit</v-btn>
  </form>
</template>
<script setup lang="ts">
import type {
  Measurement,
  MeasurementDefinition,
} from "../gen/observations-vue";
import { ref } from "vue";

const props = defineProps<{
  measurementDefinition: MeasurementDefinition;
  initialValue?: number | undefined;
}>();
const emit = defineEmits<(e: "create", m: Measurement) => void>();

const multiplier = Math.pow(10, props.measurementDefinition.exponent);
const step =
  props.measurementDefinition.step || props.measurementDefinition.step === 0
    ? props.measurementDefinition.step / multiplier
    : null;
const min =
  props.measurementDefinition.minimum ||
  props.measurementDefinition.minimum === 0
    ? props.measurementDefinition.minimum / multiplier
    : null;
const max =
  props.measurementDefinition.maximum ||
  props.measurementDefinition.maximum === 0
    ? props.measurementDefinition.maximum / multiplier
    : null;
const measurement = ref(props.initialValue ?? min);

function submit() {
  if (measurement.value === null) {
    return;
  }
  emit("create", {
    definition: props.measurementDefinition.id,
    significand: measurement.value * multiplier,
  });
}
</script>
